import '@babel/polyfill';
import 'whatwg-fetch';
import 'url-search-params-polyfill';
import window from './globalWrappers/window';
import document from './globalWrappers/document';
import jsonFetch from './utilities/jsonFetch';
import showError from  './webmailLogin/showError';

const webmailLogin = {};
webmailLogin.submitLoginAsync = async () => {
  let loginForm = document.getElementById('form');
  let email = loginForm.username.value;
  if (loginForm.hostname && !email.includes('@')) {
    email = `${email}@${loginForm.hostname.value}`;
  }
  email = encodeURIComponent(email);
  let owaInfo = {is_exchange: false};
  try {
    owaInfo = await jsonFetch({ url: `/ext/login/exchange.php?e=${email}` });
  } catch (e) {
    console.warn(e);
  }

  if (owaInfo.is_exchange) {
    let destInput = document.getElementById('form-destination');
    destInput.value = owaInfo.dest_url;
    loginForm.action = owaInfo.auth_url;
  }

  loginForm.submit();
};

webmailLogin.submitLogin = (e) => {
  let loginBtn = document.getElementById('login-btn');
  loginBtn.disabled = true;
  if (e.preventDefault) {
    e.preventDefault();
  }
  webmailLogin.submitLoginAsync();

  return false;
};

window.submitLogin = webmailLogin.submitLogin;
window.onload = showError;

export default webmailLogin;


